import React from 'react';
import { formatDate, formatLastEditTime } from './StocktakeUtils';

/**
 * Component for displaying a single stocktake row in the desktop table
 * @param {Object} props - Component props
 * @param {Object} props.stocktake - Stocktake data object
 * @param {Function} props.navigateToStocktakeDetail - Function to navigate to stocktake detail
 */
const StocktakeTableRow = ({ stocktake, navigateToStocktakeDetail }) => {
  const statusClass = stocktake.status === 1 ? 'completed' : 'active';
  const statusLabel = stocktake.status === 1 ? 'Complete' : 'In Progress';

  return (
    <tr
      onClick={() => navigateToStocktakeDetail(stocktake._id)}
      style={{ cursor: 'pointer' }}
    >
      <td>
        <span className={`forms-status ${statusClass}`}>
          {statusLabel}
        </span>
      </td>
      <td>
        <span className="forms-date">{formatDate(stocktake.date)}</span>
      </td>
      <td>{stocktake.user?.name || 'N/A'}</td>
      <td>
        <span className="forms-date">{formatLastEditTime(stocktake.lastEditTime)}</span>
      </td>
      <td>{'\u00A3'}{(stocktake.value || 0).toFixed(2)}</td>
      <td>{'\u00A3'}{(stocktake.retailValue || 0).toFixed(2)}</td>
    </tr>
  );
};

export default StocktakeTableRow;
